import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { LineReveal } from "./Reveal";

export default function Hero() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start start", "end start"],
    });
    // Very discreet parallax — no zoom, no extra blur.
    const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "6%"]);

    return (
        <section id="top" data-testid="hero" className="relative">
            <div ref={ref} className="relative w-full overflow-hidden hero-full">
                {/* Full-bleed salon photo */}
                <motion.div className="absolute inset-0" style={{ y: imgY }}>
                    <img
                        src="/photos/hero.webp"
                        alt="Salonul LadyArt — coafură blond editorial, Fălticeni"
                        className="h-full w-full object-cover"
                        style={{ objectPosition: "50% 42%" }}
                        fetchpriority="high"
                        decoding="async"
                        loading="eager"
                    />
                </motion.div>

                {/* Subtle top scrim — keeps the transparent navbar legible */}
                <div
                    className="absolute left-0 right-0 top-0 h-40"
                    style={{
                        background:
                            "linear-gradient(to bottom, rgba(31,31,31,0.4) 0%, rgba(31,31,31,0) 100%)",
                    }}
                />

                {/* Discreet left-only gradient for text legibility */}
                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(to right, rgba(31,31,31,0.5) 0%, rgba(31,31,31,0.28) 26%, rgba(31,31,31,0.06) 48%, rgba(31,31,31,0) 64%)",
                    }}
                />

                {/* Overlaid editorial text — left */}
                <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-16">
                    <motion.span
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1.2, delay: 0.2 }}
                        className="eyebrow"
                        style={{ color: "rgba(252,251,248,0.92)" }}
                    >
                        Salon de coafură • Fălticeni
                    </motion.span>

                    <h1
                        className="mt-6 font-serif font-light"
                        style={{
                            color: "var(--bg)",
                            lineHeight: 0.93,
                            fontSize: "clamp(3rem, 8vw, 8rem)",
                            textShadow: "0 2px 44px rgba(31,31,31,0.5)",
                            maxWidth: "12ch",
                        }}
                    >
                        <LineReveal
                            lines={["Unde părul", "devine artă"]}
                            delay={0.35}
                        />
                    </h1>

                    <motion.p
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.9 }}
                        className="mt-7 max-w-md font-sans text-sm leading-relaxed md:text-base"
                        style={{
                            color: "rgba(252,251,248,0.9)",
                            textShadow: "0 1px 24px rgba(31,31,31,0.55)",
                        }}
                    >
                        Culoare, lumină și styling de precizie —
                        <br className="hidden sm:block" /> gândite pentru felul în
                        care vrei să te simți.
                    </motion.p>
                </div>
            </div>
        </section>
    );
}
